/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import BookingReview from './BookingReview';
import {
  hideHeaderMenu,
  showHeaderMenu,
} from '../../../shared/helper-utils/appUtils';

function BookingReviewPage() {
  return (
    <section className="booking-review-page">
      <BookingReview />
    </section>
  );
}

export default BookingReviewPage;
